import Axios from '@/store/interfaces/Axios'
import { storage } from '@/utils/storage'
// import gql from 'graphql-tag'
// import { storage } from '@/utils/storage'

const client = new Axios('', false)

class APICraft {
  getTimeCodes (uri) {
    const request = new Promise((resolve, reject) => {
      client.get(uri)
      .then(res => {
        const result = res.data

        resolve(result)
        storage.setItem( `getTimeCodes_${JSON.stringify(uri)}`, result)
      })
      .catch(err => {
        console.error('Error catching global params ', err)
      })
    })
    const cache = storage.getItem( `getTimeCodes_${JSON.stringify(uri)}`)

    return {
      request,
      cache
    }
  }
}

export const api = new APICraft()